// extracted by mini-css-extract-plugin
module.exports = {"centeredOutboundLink":"UVPPlus_centeredOutboundLink__XEyCb","container":"UVPPlus_container__VTDf7","placeholder":"UVPPlus_placeholder__PES7Z","uvpPlus":"UVPPlus_uvpPlus__uUh0L"};